<template>
  <div class="bg" style="background: url(static/img/background.jpg)">
    <v-container grid-list-lg class="mb-5 responsive-container">
      <v-layout row justify-center wrap>
        <BackSimulator></BackSimulator>
        <v-flex xs12 md6 lg4>
          <img src="static/logo/logo.svg" width="60%" class="mx-auto mt-2" />
        </v-flex>
        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">Dados Pessoais</h1>
        </v-flex>
        <v-flex xs12 class="mb-4">
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Nome *</p>
                    <v-text-field
                      ref="nome"
                      solo
                      hide-details
                      v-model="form.nome"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.telefone.focus()"
                      @input="saveLocal"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Telefone *</p>
                    <v-text-field
                      ref="telefone"
                      type="tel"
                      inputmode="tel"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                      v-model="form.telefone"
                      placeholder="(00) 00000-0000"
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.email.focus()"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">E-mail *</p>
                    <v-text-field
                      ref="email"
                      type="email"
                      solo
                      hide-details
                      v-model="form.email"
                      :error="emailError"
                      :error-messages="emailError ? ['E-mail inválido'] : []"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.empresa.focus()"
                      @blur="validateEmail"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Empresa (Razão Social) *</p>
                    <v-text-field
                      ref="empresa"
                      solo
                      hide-details
                      v-model="form.empresa"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.cargo.focus()"
                      @input="saveLocal"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Cargo *</p>
                    <v-text-field
                      ref="cargo"
                      solo
                      hide-details
                      v-model="form.cargo"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.custo.focus()"
                      @input="saveLocal"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">
            Formulário de Caldeira
          </h1>
        </v-flex>
        <v-flex xs12 d-none>
          <v-card class="card-custom mb-2">
            <v-card-text class="card-custom-text">
              <v-container fluid>
                <v-layout row wrap align-end>
                  <v-flex xs12 sm12 md6 lg4 class="text-xs-left">
                    <p class="caption mb-2">Custo da Energia (R$/MWh) *</p>
                    <v-text-field
                      ref="custo"
                      v-model="form.custo"
                      v-money="money"
                      solo
                      hide-details
                      inputmode="decimal"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="
                        $refs.capacidade_caldeira &&
                          $refs.capacidade_caldeira[0].focus()
                      "
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg4 class="text-xs-left">
                    <p class="mb-3 mt-0">(Energia + Encargos + Impostos)</p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          v-for="(item, index) in equipamentos"
          :key="index"
          class="mb-4"
        >
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 class="pt-2">
                    <div class="compressor-card-title">
                      <p
                        class="primary--text text-uppercase font-weight-bold mb-0"
                      >
                        Caldeira {{ index + 1 }}
                      </p>
                      <v-tooltip top v-if="index !== 0">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            small
                            class="ml-auto mr-0"
                            v-on="on"
                            @click="removeCard(index)"
                          >
                            <v-icon>mdi mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Remover</span>
                      </v-tooltip>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Capacidade da Caldeira (ton/h) *</p>
                    <v-text-field
                      ref="capacidade_caldeira"
                      type="text"
                      inputmode="decimal"
                      v-model="item.capacidade_caldeira_ton_h"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9.,]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9.,]/.test(text)) e.preventDefault();
                        }
                      "
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Pressão (bar a) *</p>
                    <v-text-field
                      ref="pressao"
                      type="text"
                      inputmode="decimal"
                      v-model="item.pressao_bar_a"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9.,]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9.,]/.test(text)) e.preventDefault();
                        }
                      "
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Vazão Média (ton/h) *</p>
                    <v-text-field
                      ref="vazao_media"
                      type="text"
                      inputmode="decimal"
                      v-model="item.vazao_media_ton_h"
                      @keydown="
                        (e) => {
                          if (e.key.length === 1 && !/^[0-9.,]$/.test(e.key))
                            e.preventDefault();
                        }
                      "
                      @paste="
                        (e) => {
                          const text = e.clipboardData.getData('text/plain');
                          if (/[^0-9.,]/.test(text)) e.preventDefault();
                        }
                      "
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Combustível *</p>
                    <v-select
                      ref="combustivel"
                      v-model="item.combustivel"
                      :items="combustiveis"
                      solo
                      hide-details
                    />
                  </v-flex>

                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Operação Horas/dia *</p>
                    <v-select
                      v-model="item.operacao_horas_dia"
                      solo
                      hide-details
                      :items="horas_dias"
                    >
                    </v-select>
                    <!-- <v-text-field
                      ref="horas"
                      type="text"
                      inputmode="numeric"
                      v-model="item.operacao_horas_dia"
                      v-mask="'##'"
                      placeholder="Ex.: 24"
                      solo
                      hide-details
                      append-icon="mdi mdi-timer"
                      :attrs="{ returnKeyType: 'next' }"
                      @blur="validateHours(item)"
                    /> -->
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Operação Dias/Semana *</p>
                    <v-select
                      v-model="item.operacao_dias_semana"
                      solo
                      hide-details
                      :items="dias_semana"
                    >
                    </v-select>
                    <!-- <v-text-field
                      ref="dias_semana"
                      type="text"
                      inputmode="numeric"
                      v-model="item.operacao_dias_semana"
                      v-mask="'#'"
                      placeholder="Ex.: 7"
                      solo
                      hide-details
                      append-icon="mdi mdi-calendar"
                      :attrs="{ returnKeyType: 'next' }"
                      @blur="validateDaysWeek(item)"
                    /> -->
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Operação Semanas/Ano *</p>
                    <v-text-field
                      ref="semanas_ano"
                      type="text"
                      inputmode="numeric"
                      v-model="item.operacao_semanas_ano"
                      v-mask="'##'"
                      placeholder="Ex.: 52"
                      solo
                      hide-details
                      append-icon="mdi mdi-calendar-range"
                      :attrs="{ returnKeyType: 'next' }"
                      @blur="validateWeeksYear(item)"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 class="text-xs-left">
                    <p class="caption mb-2">Comparar com Caldeira: *</p>
                    <v-select
                      ref="comparar_com"
                      v-model="item.comparar_com_caldeira"
                      :items="combustiveis"
                      solo
                      hide-details
                    />
                  </v-flex>

                  <v-flex xs12 class="text-xs-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          color="primary"
                          class="ml-auto mr-1"
                          v-on="on"
                          @click="addCard"
                        >
                          <v-icon>mdi mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 class="text-xs-right pb-5">
          <v-btn color="primary" @click="sendForm()">
            Enviar dados
            <v-icon right>mdi mdi-send</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      v-model="showDialogDetalhesSuperiror"
      max-width="500px"
      persistent
    >
      <v-card class="pb-3">
        <v-card-title>
          <h3>Valor dos combustíveis</h3>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-container fluid grid-list-lg>
            <v-layout wrap fluid>
              <v-flex xs12>
                <div
                  style="
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: start;
                  "
                >
                  <div
                    style="
                      width: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: space-around;
                    "
                    v-for="(mds, key) in combustiveis_modal"
                    class="mb-2"
                    :key="key"
                  >
                    <div style="width: 200px; text-align: left">
                      {{ mds.nome }} {{ mds.medida }}
                    </div>
                    <div style="width: 200px">
                      <v-text-field
                        v-model="mds.valor"
                        v-money="money"
                        solo
                        hide-details
                        inputmode="decimal"
                      />
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex">
          <v-btn
            @click="showDialogDetalhesSuperiror = false"
            flat
            class="ma-2 error"
            >Fechar</v-btn
          >
          <v-btn @click="salvaPlanilha()" flat class="ma-2 primary"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _base;

try {
  _base = require("@/page/_base.vue").default;
} catch (err) {
  _base = require("@/framework/page/_base.vue").default;
}

import { VMoney } from "v-money";

import Swal from "sweetalert2";
import { mask } from "vue-the-mask";

import BackSimulator from "@/page/widget/backSimulator.vue";
export default {
  extends: _base,

  data() {
    return {
      dias_mes: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
      ],
      horas_dias: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24,
      ],
      dias_semana: [1, 2, 3, 4, 5, 6, 7],
      showDialogDetalhesSuperiror: false,
      combustiveis_modal: [],
      mode: "Vazão",
      id_mode: 0,
      form: {
        nome: "",
        telefone: "",
        email: "",
        empresa: "",
        cargo: "",
        custo: 0,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 2,
        masked: false,
      },
      emailError: false,
      equipamentos: [
        {
          capacidade_caldeira_ton_h: "",
          pressao_bar_a: "",
          vazao_media_ton_h: "",
          combustivel: "",
          operacao_horas_dia: "",
          operacao_dias_semana: "",
          operacao_semanas_ano: "",
          comparar_com_caldeira: "",
          operacao_horas_dia_error: false,
          operacao_dias_semana_error: false,
          operacao_semanas_ano_error: false,
        },
      ],
      endpoint: global.config.endpoint,
      combustiveis: [
        "GN",
        "GLP",
        "Lenha",
        "Cavaco",
        "Elétrica",
        "Óleo Combustível",
      ],
    };
  },
  mounted() {
    // Check for mode in URL query params and override this.mode if valid
    // console.log(this.$route);
    const urlMode =
      this.$route && this.$route.query ? this.$route.query.mode : null;

    if (urlMode === "vazao") {
      this.mode = "Vazão";
      this.id_mode = 0;
    }

    if (urlMode === "valvula") {
      this.mode = "Válvula";
      this.id_mode = 1;
    }

    // const saved = localStorage.getItem("iluminacao_form");
    // if (saved) {
    //   const parsed = JSON.parse(saved);
    //   this.form = parsed.form || this.form;
    //   this.equipamentos = parsed.equipamentos || this.equipamentos;
    // }
  },
  methods: {
    retorna() {
      this.$router.back();
    },
    validateHours(item) {
      const horas = Number(item.operacao_horas_dia);

      if (!horas || horas <= 0 || horas > 24) {
        item.operacao_horas_dia = "";
        item.operacao_horas_dia_error = true;

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Operação Horas/dia</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                Deve ser entre <b style="font-weight: bold !important;">1</b> e <b style="font-weight: bold !important;">24</b>.
              </p>
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">Este campo não pode estar vazio</p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      } else {
        item.operacao_horas_dia_error = false;
      }
    },
    validateDaysWeek(item) {
      const dias = Number(item.operacao_dias_semana);

      if (!dias || dias <= 0 || dias > 7) {
        item.operacao_dias_semana = "";
        item.operacao_dias_semana_error = true;

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Operação Dias/Semana</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                Deve ser entre <b style="font-weight: bold !important;">1</b> e <b style="font-weight: bold !important;">7</b>.
              </p>
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">Este campo não pode estar vazio</p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      } else {
        item.operacao_dias_semana_error = false;
      }
    },
    validateWeeksYear(item) {
      const semanas = Number(item.operacao_semanas_ano);

      if (!semanas || semanas <= 0 || semanas > 52) {
        item.operacao_semanas_ano = "";
        item.operacao_semanas_ano_error = true;

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Operação Semanas/Ano</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                Deve ser entre <b style="font-weight: bold !important;">1</b> e <b style="font-weight: bold !important;">52</b>.
              </p>
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">Este campo não pode estar vazio</p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      } else {
        item.operacao_semanas_ano_error = false;
      }
    },
    async sendForm() {
      let error = "";

      if (this.validaequipamentos()) {
        error = "Preencha todos os campos dos equipamentos!";
      }

      if (this.emailError) {
        error = "Por favor, informe um e-mail válido";
      }

      // if (this.form.custo == "") {
      //   error = "Informe o custo da energia";
      // }

      if (this.form.cargo == "") {
        error = "Informe o cargo";
      }

      if (this.form.empresa == "") {
        error = "Informe a razão social";
      }

      if (this.form.email == "") {
        error = "Inserir o e-mail";
      }

      if (this.form.telefone == "") {
        error = "Informe o telefone";
      }
      if (this.form.nome == "") {
        error = "Informa o nome";
      }

      if (error != "") {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                       ${error}
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }

      if (this.equipamentos && this.equipamentos.length > 10) {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Limite de equipamentes é 10</strong>",
          confirmButtonText: "Ok",
        });

        return;
      }

      this.combustiveis_modal = [];

      let arr_aux = [];

      for (let index = 0; index < this.equipamentos.length; index++) {
        const element = this.equipamentos[index];

        let medida = "";
        let medida2 = "";

        if (element.combustivel == "GN") {
          medida = "(R$/m3)";
        }

        if (
          element.combustivel == "GLP" ||
          element.combustivel == "Óleo Combustível"
        ) {
          medida = "(R$/kg)";
        }

        if (element.combustivel == "Lenha" || element.combustivel == "Cavaco") {
          medida = "(R$/ton)";
        }

        if (element.combustivel == "Elétrica") {
          medida = "(R$/MWh)";
        }

        if (!arr_aux.includes(element.combustivel)) {
          this.combustiveis_modal.push({
            nome: element.combustivel,
            valor: 0,
            medida: medida,
          });

          arr_aux.push(element.combustivel);
        }

        if (!arr_aux.includes(element.comparar_com_caldeira)) {
          if (element.comparar_com_caldeira == "GN") {
            medida2 = "(R$/m3)";
          }

          if (
            element.comparar_com_caldeira == "GLP" ||
            element.comparar_com_caldeira == "Óleo Combustível"
          ) {
            medida2 = "(R$/kg)";
          }

          if (
            element.comparar_com_caldeira == "Lenha" ||
            element.comparar_com_caldeira == "Cavaco"
          ) {
            medida2 = "(R$/ton)";
          }
          if (element.comparar_com_caldeira == "Elétrica") {
            medida2 = "(R$/MWh)";
          }
          this.combustiveis_modal.push({
            nome: element.comparar_com_caldeira,
            valor: 0,
            medida: medida2,
          });

          arr_aux.push(element.comparar_com_caldeira);
        }
      }

      this.showDialogDetalhesSuperiror = true;
    },

    async salvaPlanilha() {
      let error = false;

      for (let index = 0; index < this.combustiveis_modal.length; index++) {
        const element = this.combustiveis_modal[index];

        if (element.valor <= 0) {
          error = true;
        }
      }

      if (error) {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                      Informe o valor de todos os combustíveis
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }

      const formData = {
        form: this.form,
        equipamentos: this.equipamentos,
        id_mode: this.id_mode,
        combustiveis_modal: this.combustiveis_modal,
      };

      Swal.showLoading();
      let valores = JSON.stringify(formData);

      let res = await this.callLocalAction("save_estudo", {
        dados: valores,
      });

      if (res && res.ok && res.ok.ok) {
        this.showDialogDetalhesSuperiror = false;
        Swal.fire({
          icon: "success",
          title:
            "<strong style='font-size: 20px !important;'>Resultado enviado</strong>",
          html: `
              <div style="padding: 10px;">
                  <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                    O resultado da simulação foi enviado para o e-mail informado: <b>${this.form.email}</b>
                  </p>
                </div>
            `,
          confirmButtonText: "Ok",
          confirmButtonColor: "#68b842",
        }).then(async () => {
          this.retorna();
        });
      } else {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Erro ao salvar</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                      Não foi possível realizar o estudo
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }
    },
    validaequipamentos() {
      const requiredFields = [
        "capacidade_caldeira_ton_h",
        "pressao_bar_a",
        "vazao_media_ton_h",
        "combustivel",
        "operacao_horas_dia",
        "operacao_dias_semana",
        "operacao_semanas_ano",
        "comparar_com_caldeira",
      ];

      for (let i = 0; i < this.equipamentos.length; i++) {
        const instalacao = this.equipamentos[i];

        if (requiredFields.some((field) => instalacao[field] === "")) {
          return true; // encontrou campo inválido
        }
      }

      return false;
    },
    maskTelefone() {
      let v = this.form.telefone.replace(/\D/g, "");

      if (v.length > 11) v = v.slice(0, 11);

      if (v.length > 10) {
        v = v.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
      } else if (v.length > 6) {
        v = v.replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3");
      } else if (v.length > 2) {
        v = v.replace(/^(\d{2})(\d{0,5})$/, "($1) $2");
      } else {
        v = v.replace(/^(\d*)$/, "($1");
      }

      this.form.telefone = v;
      this.saveLocal();
    },

    validateEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailError = !regex.test(this.form.email);
      this.saveLocal();
    },

    saveLocal() {
      // localStorage.setItem(
      //   "iluminacao_form",
      //   JSON.stringify({
      //     form: this.form,
      //     equipamentos: this.equipamentos,
      //   })
      // );
    },

    addCard() {
      this.equipamentos.push({
        capacidade_caldeira_ton_h: "",
        pressao_bar_a: "",
        vazao_media_ton_h: "",
        combustivel: "",
        operacao_horas_dia: "",
        operacao_dias_semana: "",
        operacao_semanas_ano: "",
        comparar_com_caldeira: "",
        operacao_horas_dia_error: false,
        operacao_dias_semana_error: false,
        operacao_semanas_ano_error: false,
      });
      this.saveLocal();
    },
    removeCard(index) {
      if (this.equipamentos.length === 1) return;

      this.equipamentos.splice(index, 1);
      this.saveLocal();
    },
  },
  directives: {
    money: VMoney,
    mask,
  },
  components: {
    BackSimulator,
  },
};
</script>

<style lang="scss">
@import "@/theme/styles/base.scss";

.bg {
  min-height: 100svh;
  min-width: 100svw;
  background-size: cover !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
}

.card-custom {
  backdrop-filter: blur(6px) brightness(0.8) !important;
  background: tint($body-color, 70%);
  border: 1px solid tint($brand-primary, 90%) !important;
  border-radius: 2.4rem !important;
  margin-bottom: -16px;

  .card-custom-text {
    padding: 16px !important;

    @media (min-width: 960px) {
      padding: 16px 16px 16px 16px !important;
    }
  }
}

.v-select__selection.v-select__selection--comma,
.v-input {
  font-size: 14px !important;
}

.v-text-field__details {
  display: none !important;
}

.primary {
  background-color: $brand-default !important;
  border-color: $brand-default !important;
}

.v-text-field input[type="number"]::-webkit-inner-spin-button,
.v-text-field input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.v-text-field input[type="number"] {
  -moz-appearance: textfield;
}

.responsive-container {
  max-width: 1264px; // padrão lg do Vuetify
  padding-left: 16px;
  padding-right: 16px;

  @media (max-width: 960px) {
    max-width: 100%;
  }
}

.compressor-card-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-plus {
  margin-top: 32px;
}
</style>
